"use client";
import "./Tags.css";
import { ITags } from "./interfaces";

export const Tags: React.FC<ITags> = ({ tags, filter, handleClick }) => {
  return (
    <div className={"portfolio__tags"}>
      {tags.map((n, i) => (
        <span
          className={`portfolio__tag ${filter === n ? "enabled" : "disabled"}`}
          onClick={() => handleClick(n)}
          key={i}
        >
          {n}
        </span>
      ))}
    </div>
  );
};
